import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <div className="not-found-actions">
          <Link to="/admin" className="btn-primary">
            Go to Home
          </Link>
          <Link to="/transfer" className="btn-secondary">
            Token Transfer
          </Link>
          <Link to="/deploy" className="btn-secondary">
            Deploy Contract
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;